import { Action, AppState } from "./AppProvider";

// Define the reducer function
export const appStateReducer = (state: AppState, action: Action): AppState => {
    switch (action.type) {
        case "UPDATE_CURRENT_CHAT":
            return { ...state, currentChat: action.payload };
        case "UPDATE_SHOW_HEADER":
            return { ...state, showHeader: action.payload };
        case "UPDATE_SHOW_USAGE_DISCLAIMER":
            return { ...state, showUsageDisclaimer: action.payload };
        case "UPDATE_CONSENT_GIVEN":
            return { ...state, consentGiven: action.payload };
        default:
            return state;
    }
};